module.exports = __webpack_public_path__ + "static/media/thumb_XPWU3286_1024a.050c2285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_XPWU3286_1024a.jpg
// module id = 156
// module chunks = 0